export var defaultProps = {
    defaultValue: 0,
    count: 5,
    allowHalf: false,
    allowClear: true,
    onChange: function (value) { },
    onBeforeChange: function () { return true; },
    character: '★',
    onHoverChange: function (value) { },
    disabled: false,
    tabIndex: 0,
    type: 'image',
    checkedIcon: 'https://img10.360buyimg.com/imagetools/jfs/t1/165373/8/8404/851/603f7f64Ebc2fa1ae/ecc20071f7bf946d.png',
    uncheckedIcon: 'https://img14.360buyimg.com/imagetools/jfs/t1/166450/11/8893/376/603f7f64E54d95a25/93e7a23b1e2b131a.png',
    onBlur: function () { },
    onFocus: function () { },
    characterRender: false,
    autoFocus: false,
    readonly: false,
};
